import { combineReducers } from "redux";
import accountCreationReducer from "./AccountCreationSlice";
import providerAccountCreationReducer from "./ProviderAccountCreationSlice";
import errorBoundaryStrategyReducer from "./ErrorBoundaryStrategySlice";
import linkApplicationReducer from "./LinkApplicationSlice";
import localeReducer from "./LocaleSlice";
import loginReducer from "./LoginSlice";
import referenceDataReducer from "./ReferenceDataSlice";
import utilityDataReducer from "./UtilityDataSlice";
import myProfileReducer from "./MyProfileSlice";
import authorizationReducer from "./AuthorizationSlice";
import timeShifterReducer from "./TimeShifterSlice";
import providerRequestsReducer from "./ProviderRequestsSlice";

const rootReducer = combineReducers({
  errorBoundary: errorBoundaryStrategyReducer,
  locale: localeReducer,
  utilityData: utilityDataReducer,
  accountCreation: accountCreationReducer,
  login: loginReducer,
  linkApplication: linkApplicationReducer,
  providerAccountCreation: providerAccountCreationReducer,
  referenceData: referenceDataReducer,
  myProfile: myProfileReducer,
  authorization: authorizationReducer,
  timeShifter: timeShifterReducer,
  providerRequests: providerRequestsReducer,
});

export default rootReducer;
